<template>
  <div
    v-if="isShow"
    ref="iuOverlay"
    class="iu-widget__overlay"
    :class="{ 'iu-widget--in-drag': inDrag }"
    @click="isShow = false"
    @dragover.prevent.stop="inDrag = true"
    @dragleave.prevent.stop="inDrag = false"
    @drop.prevent.stop="uploadFromDrop"
  >
    <div v-if="settings.custom_style" v-html="settings.custom_style" />
    <div
      ref="iuPopup"
      class="iu-widget__popup"
      @click.stop
      @dragover.prevent.stop="inDrag = true"
    >
      <template v-if="currentStep !== 'congrats'">
        <div class="iu-widget__close" @click="isShow = false">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1C8.33333 8.33333 23 23 23 23"
              stroke="#2C2C2C"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M23 1C15.6667 8.33333 1 23 1 23"
              stroke="#2C2C2C"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <div class="iu-widget__title">Добавить образ</div>
        <div class="iu-widget__post-form">
          <label class="iu-widget--required">Имя </label>
          <input v-model="username" type="text" @input="error = null" />
          <label class="iu-widget--required">E-mail </label>
          <input v-model="email" type="text" @input="error = null" />
          <label>Комментарии</label>
          <textarea
            v-model="caption"
            type="text"
            rows="3"
            :placeholder="settings.caption_placeholder"
          />
        </div>
        <div
          class="iu-widget__title iu-widget__title--medium iu-widget__title--add-photo"
        >
          Добавить медиа
        </div>
        <div
          v-if="!limitIsFull && !uploadProcess"
          class="iu-widget-upload iu-widget-upload--short"
        >
          <svg
            width="25"
            height="18"
            viewBox="0 0 25 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.5092 0.0252809C9.5092 0.0391854 9.46319 0.0505618 9.40695 0.0505618C9.35072 0.0505618 9.3047 0.0619382 9.3047 0.0758427C9.3047 0.0897472 9.28423 0.101124 9.25923 0.101124C9.2342 0.101124 9.19716 0.123876 9.17689 0.151685C9.15662 0.179494 9.12508 0.202247 9.1068 0.202247C9.0885 0.202247 9.01051 0.264565 8.93349 0.340736C8.85647 0.416907 8.79346 0.494039 8.79346 0.51214C8.79346 0.530216 8.77045 0.561413 8.74233 0.581461C8.71421 0.601508 8.69121 0.63814 8.69121 0.66289C8.69121 0.687615 8.6797 0.707865 8.66564 0.707865C8.65158 0.707865 8.64008 0.728115 8.64008 0.75284C8.64008 0.77759 8.61708 0.814222 8.58896 0.83427C8.56084 0.854317 8.53783 0.890949 8.53783 0.915699C8.53783 0.940424 8.52633 0.960674 8.51227 0.960674C8.49821 0.960674 8.48671 0.980924 8.48671 1.00565C8.48671 1.0304 8.4637 1.06703 8.43558 1.08708C8.40746 1.10713 8.38446 1.14376 8.38446 1.16851C8.38446 1.19323 8.37296 1.21348 8.3589 1.21348C8.34484 1.21348 8.33333 1.23373 8.33333 1.25846C8.33333 1.28321 8.31033 1.31984 8.28221 1.33989C8.25409 1.35994 8.23108 1.39657 8.23108 1.42132C8.23108 1.44604 8.21958 1.46629 8.20552 1.46629C8.19146 1.46629 8.17996 1.48654 8.17996 1.51127C8.17996 1.53602 8.15695 1.57265 8.12883 1.5927C8.10072 1.61274 8.07771 1.64938 8.07771 1.67413C8.07771 1.69885 8.06621 1.7191 8.05215 1.7191C8.03809 1.7191 8.02658 1.73935 8.02658 1.76408C8.02658 1.78883 8.00358 1.82546 7.97546 1.84551C7.94734 1.86555 7.92434 1.90219 7.92434 1.92694C7.92434 1.95166 7.91283 1.97191 7.89877 1.97191C7.88471 1.97191 7.87321 1.99216 7.87321 2.01689C7.87321 2.04164 7.8502 2.07827 7.82209 2.09831C7.79397 2.11836 7.77096 2.15012 7.77096 2.1689C7.77096 2.27849 7.86122 2.27528 4.7692 2.27528C2.83377 2.27528 1.84049 2.28385 1.84049 2.30056C1.84049 2.31447 1.79448 2.32584 1.73824 2.32584C1.682 2.32584 1.63599 2.33722 1.63599 2.35112C1.63599 2.36503 1.60148 2.3764 1.5593 2.3764C1.51713 2.3764 1.48262 2.38778 1.48262 2.40169C1.48262 2.41559 1.44811 2.42697 1.40593 2.42697C1.36375 2.42697 1.32924 2.43834 1.32924 2.45225C1.32924 2.46615 1.30624 2.47753 1.27812 2.47753C1.25 2.47753 1.22699 2.4889 1.22699 2.50281C1.22699 2.51671 1.20399 2.52809 1.17587 2.52809C1.14775 2.52809 1.12474 2.53947 1.12474 2.55337C1.12474 2.56728 1.10174 2.57865 1.07362 2.57865C1.0455 2.57865 1.02249 2.59003 1.02249 2.60393C1.02249 2.61784 1.00202 2.62921 0.977019 2.62921C0.951994 2.62921 0.914954 2.65197 0.894683 2.67978C0.874412 2.70758 0.842945 2.73034 0.824719 2.73034C0.781544 2.73034 0.408998 3.09878 0.408998 3.14148C0.408998 3.15951 0.385992 3.19063 0.357873 3.21067C0.329755 3.23072 0.306748 3.26735 0.306748 3.2921C0.306748 3.31683 0.295245 3.33708 0.281186 3.33708C0.267127 3.33708 0.255624 3.35983 0.255624 3.38764C0.255624 3.41545 0.244121 3.4382 0.230061 3.4382C0.216002 3.4382 0.204499 3.46095 0.204499 3.48876C0.204499 3.51657 0.192996 3.53933 0.178937 3.53933C0.164877 3.53933 0.153374 3.56208 0.153374 3.58989C0.153374 3.6177 0.141871 3.64045 0.127812 3.64045C0.113753 3.64045 0.102249 3.68596 0.102249 3.74157C0.102249 3.79719 0.0907464 3.8427 0.0766871 3.8427C0.0626278 3.8427 0.0511247 3.89958 0.0511247 3.9691C0.0511247 4.03862 0.0396217 4.09551 0.0255624 4.09551C0.00858896 4.09551 0 6.11798 0 10.1124C0 14.1067 0.00858896 16.1292 0.0255624 16.1292C0.0396217 16.1292 0.0511247 16.1861 0.0511247 16.2556C0.0511247 16.3251 0.0626278 16.382 0.0766871 16.382C0.0907464 16.382 0.102249 16.4275 0.102249 16.4831C0.102249 16.5388 0.113753 16.5843 0.127812 16.5843C0.141871 16.5843 0.153374 16.6184 0.153374 16.6601C0.153374 16.7018 0.164877 16.736 0.178937 16.736C0.192996 16.736 0.204499 16.7587 0.204499 16.7865C0.204499 16.8143 0.216002 16.8371 0.230061 16.8371C0.244121 16.8371 0.255624 16.8573 0.255624 16.8821C0.255624 16.9068 0.27863 16.9434 0.306748 16.9635C0.334867 16.9835 0.357873 17.0156 0.357873 17.0348C0.357873 17.0539 0.392382 17.1015 0.43456 17.1404C0.476738 17.1794 0.511247 17.2243 0.511247 17.2402C0.511247 17.2778 0.628042 17.3933 0.665976 17.3933C0.682081 17.3933 0.72748 17.4274 0.766871 17.4691C0.806263 17.5108 0.854371 17.5449 0.873722 17.5449C0.893098 17.5449 0.925537 17.5677 0.945808 17.5955C0.966079 17.6233 1.00312 17.6461 1.02814 17.6461C1.05314 17.6461 1.07362 17.6574 1.07362 17.6713C1.07362 17.6853 1.09663 17.6966 1.12474 17.6966C1.15286 17.6966 1.17587 17.708 1.17587 17.7219C1.17587 17.7358 1.19888 17.7472 1.22699 17.7472C1.25511 17.7472 1.27812 17.7586 1.27812 17.7725C1.27812 17.7864 1.31263 17.7978 1.35481 17.7978C1.39698 17.7978 1.43149 17.8091 1.43149 17.823C1.43149 17.8369 1.466 17.8483 1.50818 17.8483C1.55036 17.8483 1.58487 17.8597 1.58487 17.8736C1.58487 17.8875 1.61938 17.8989 1.66155 17.8989C1.70373 17.8989 1.73824 17.9103 1.73824 17.9242C1.73824 17.9382 1.80642 17.9494 1.89162 17.9494C1.97681 17.9494 2.04499 17.9607 2.04499 17.9747C2.04499 17.9915 5.54703 18 12.5 18C19.453 18 22.955 17.9915 22.955 17.9747C22.955 17.9607 23.0232 17.9494 23.1084 17.9494C23.1936 17.9494 23.2618 17.9382 23.2618 17.9242C23.2618 17.9103 23.2963 17.8989 23.3384 17.8989C23.3806 17.8989 23.4151 17.8875 23.4151 17.8736C23.4151 17.8597 23.4496 17.8483 23.4918 17.8483C23.534 17.8483 23.5685 17.8369 23.5685 17.823C23.5685 17.8091 23.603 17.7978 23.6452 17.7978C23.6874 17.7978 23.7219 17.7864 23.7219 17.7725C23.7219 17.7586 23.7449 17.7472 23.773 17.7472C23.8011 17.7472 23.8241 17.7358 23.8241 17.7219C23.8241 17.708 23.8471 17.6966 23.8753 17.6966C23.9034 17.6966 23.9264 17.6853 23.9264 17.6713C23.9264 17.6574 23.9469 17.6461 23.9719 17.6461C23.9969 17.6461 24.0339 17.6233 24.0542 17.5955C24.0745 17.5677 24.1069 17.5449 24.1263 17.5449C24.1456 17.5449 24.1937 17.5108 24.2331 17.4691C24.2725 17.4274 24.3179 17.3933 24.334 17.3933C24.372 17.3933 24.4888 17.2778 24.4888 17.2402C24.4888 17.2243 24.5233 17.1794 24.5654 17.1404C24.6076 17.1015 24.6421 17.0539 24.6421 17.0348C24.6421 17.0156 24.6651 16.9835 24.6933 16.9635C24.7214 16.9434 24.7444 16.9068 24.7444 16.8821C24.7444 16.8573 24.7559 16.8371 24.7699 16.8371C24.784 16.8371 24.7955 16.8143 24.7955 16.7865C24.7955 16.7587 24.807 16.736 24.8211 16.736C24.8351 16.736 24.8466 16.7018 24.8466 16.6601C24.8466 16.6184 24.8581 16.5843 24.8722 16.5843C24.8862 16.5843 24.8978 16.5388 24.8978 16.4831C24.8978 16.4275 24.9093 16.382 24.9233 16.382C24.9374 16.382 24.9489 16.3251 24.9489 16.2556C24.9489 16.1861 24.9604 16.1292 24.9744 16.1292C24.9914 16.1292 25 14.1067 25 10.1124C25 6.11798 24.9914 4.09551 24.9744 4.09551C24.9604 4.09551 24.9489 4.03862 24.9489 3.9691C24.9489 3.89958 24.9374 3.8427 24.9233 3.8427C24.9093 3.8427 24.8978 3.79719 24.8978 3.74157C24.8978 3.68596 24.8862 3.64045 24.8722 3.64045C24.8581 3.64045 24.8466 3.6177 24.8466 3.58989C24.8466 3.56208 24.8351 3.53933 24.8211 3.53933C24.807 3.53933 24.7955 3.51657 24.7955 3.48876C24.7955 3.46095 24.784 3.4382 24.7699 3.4382C24.7559 3.4382 24.7444 3.41545 24.7444 3.38764C24.7444 3.35983 24.7329 3.33708 24.7188 3.33708C24.7048 3.33708 24.6933 3.31683 24.6933 3.2921C24.6933 3.26735 24.6702 3.23072 24.6421 3.21067C24.614 3.19063 24.591 3.15951 24.591 3.14148C24.591 3.09878 24.2185 2.73034 24.1753 2.73034C24.1571 2.73034 24.1256 2.70758 24.1053 2.67978C24.085 2.65197 24.048 2.62921 24.023 2.62921C23.998 2.62921 23.9775 2.61784 23.9775 2.60393C23.9775 2.59003 23.9545 2.57865 23.9264 2.57865C23.8983 2.57865 23.8753 2.56728 23.8753 2.55337C23.8753 2.53947 23.8522 2.52809 23.8241 2.52809C23.796 2.52809 23.773 2.51671 23.773 2.50281C23.773 2.4889 23.75 2.47753 23.7219 2.47753C23.6938 2.47753 23.6708 2.46615 23.6708 2.45225C23.6708 2.43834 23.6362 2.42697 23.5941 2.42697C23.5519 2.42697 23.5174 2.41559 23.5174 2.40169C23.5174 2.38778 23.4829 2.3764 23.4407 2.3764C23.3985 2.3764 23.364 2.36503 23.364 2.35112C23.364 2.33722 23.318 2.32584 23.2618 2.32584C23.2055 2.32584 23.1595 2.31447 23.1595 2.30056C23.1595 2.2839 22.3537 2.27528 20.7932 2.27528C18.2823 2.27528 18.3538 2.27857 18.3538 2.16331C18.3538 2.14147 18.3423 2.1236 18.3282 2.1236C18.3142 2.1236 18.3027 2.10335 18.3027 2.07862C18.3027 2.05387 18.2797 2.01724 18.2515 1.99719C18.2234 1.97714 18.2004 1.94051 18.2004 1.91576C18.2004 1.89104 18.1889 1.87079 18.1748 1.87079C18.1608 1.87079 18.1493 1.85054 18.1493 1.82581C18.1493 1.80106 18.1263 1.76443 18.0982 1.74438C18.07 1.72433 18.047 1.6877 18.047 1.66295C18.047 1.63823 18.0355 1.61798 18.0215 1.61798C18.0074 1.61798 17.9959 1.59773 17.9959 1.573C17.9959 1.54825 17.9729 1.51162 17.9448 1.49157C17.9167 1.47153 17.8937 1.43489 17.8937 1.41014C17.8937 1.38542 17.8822 1.36517 17.8681 1.36517C17.854 1.36517 17.8425 1.34492 17.8425 1.32019C17.8425 1.29544 17.8195 1.25881 17.7914 1.23876C17.7633 1.21872 17.7403 1.18208 17.7403 1.15733C17.7403 1.13261 17.7288 1.11236 17.7147 1.11236C17.7007 1.11236 17.6892 1.09211 17.6892 1.06738C17.6892 1.04263 17.6662 1.006 17.638 0.985955C17.6099 0.965907 17.5869 0.929275 17.5869 0.904525C17.5869 0.879801 17.5754 0.859551 17.5613 0.859551C17.5473 0.859551 17.5358 0.8393 17.5358 0.814576C17.5358 0.789826 17.5128 0.753194 17.4847 0.733146C17.4565 0.713098 17.4335 0.676466 17.4335 0.651716C17.4335 0.626992 17.422 0.606742 17.408 0.606742C17.3939 0.606742 17.3824 0.588565 17.3824 0.566317C17.3824 0.544096 17.3479 0.494014 17.3057 0.455056C17.2635 0.416098 17.229 0.366017 17.229 0.343795C17.229 0.321548 17.2107 0.303371 17.1882 0.303371C17.1657 0.303371 17.1151 0.269242 17.0757 0.227528C17.0363 0.185815 16.9856 0.151685 16.9632 0.151685C16.9407 0.151685 16.9223 0.140309 16.9223 0.126404C16.9223 0.1125 16.8993 0.101124 16.8712 0.101124C16.843 0.101124 16.82 0.0897472 16.82 0.0758427C16.82 0.0619382 16.774 0.0505618 16.7178 0.0505618C16.6616 0.0505618 16.6155 0.0391854 16.6155 0.0252809C16.6155 0.00854494 15.4141 0 13.0624 0C10.7106 0 9.5092 0.00854494 9.5092 0.0252809ZM16.2972 1.17442C16.3317 1.20855 16.3599 1.25406 16.3599 1.27555C16.3599 1.29704 16.3714 1.31461 16.3855 1.31461C16.3995 1.31461 16.411 1.33486 16.411 1.35958C16.411 1.38433 16.434 1.42096 16.4622 1.44101C16.4903 1.46106 16.5133 1.49519 16.5133 1.51685C16.5133 1.53852 16.5363 1.57265 16.5644 1.5927C16.5925 1.61274 16.6155 1.64687 16.6155 1.66854C16.6155 1.6902 16.6385 1.72433 16.6667 1.74438C16.6948 1.76443 16.7178 1.80106 16.7178 1.82581C16.7178 1.85054 16.7293 1.87079 16.7434 1.87079C16.7574 1.87079 16.7689 1.89104 16.7689 1.91576C16.7689 1.94051 16.7919 1.97714 16.82 1.99719C16.8482 2.01724 16.8712 2.05137 16.8712 2.07303C16.8712 2.0947 16.8942 2.12883 16.9223 2.14888C16.9504 2.16892 16.9734 2.20556 16.9734 2.23031C16.9734 2.25503 16.9849 2.27528 16.999 2.27528C17.013 2.27528 17.0245 2.29553 17.0245 2.32026C17.0245 2.34501 17.0475 2.38164 17.0757 2.40169C17.1038 2.42173 17.1268 2.45586 17.1268 2.47753C17.1268 2.49919 17.1498 2.53332 17.1779 2.55337C17.206 2.57342 17.229 2.60755 17.229 2.62921C17.229 2.65088 17.252 2.68501 17.2802 2.70506C17.3083 2.7251 17.3313 2.76174 17.3313 2.78649C17.3313 2.81121 17.3428 2.83146 17.3569 2.83146C17.3709 2.83146 17.3824 2.85171 17.3824 2.87644C17.3824 2.90119 17.4054 2.93782 17.4335 2.95786C17.4617 2.97791 17.4847 3.01204 17.4847 3.03371C17.4847 3.05537 17.5077 3.0895 17.5358 3.10955C17.5639 3.1296 17.5869 3.16373 17.5869 3.18539C17.5869 3.20706 17.6099 3.24119 17.638 3.26124C17.6662 3.28128 17.6892 3.31792 17.6892 3.34267C17.6892 3.38549 17.8151 3.38764 20.3221 3.38764C22.0603 3.38764 22.955 3.39624 22.955 3.41292C22.955 3.42683 23.001 3.4382 23.0573 3.4382C23.1135 3.4382 23.1595 3.44958 23.1595 3.46348C23.1595 3.47739 23.1825 3.48876 23.2106 3.48876C23.2388 3.48876 23.2618 3.50014 23.2618 3.51405C23.2618 3.52795 23.2848 3.53933 23.3129 3.53933C23.341 3.53933 23.364 3.5507 23.364 3.56461C23.364 3.57851 23.3816 3.58989 23.403 3.58989C23.4538 3.58989 23.6708 3.8045 23.6708 3.85468C23.6708 3.87589 23.6823 3.89326 23.6963 3.89326C23.7104 3.89326 23.7219 3.91601 23.7219 3.94382C23.7219 3.97163 23.7334 3.99438 23.7474 3.99438C23.7615 3.99438 23.773 4.01713 23.773 4.04494C23.773 4.07275 23.7845 4.09551 23.7986 4.09551C23.8126 4.09551 23.8241 4.14101 23.8241 4.19663C23.8241 4.25225 23.8356 4.29775 23.8497 4.29775C23.8667 4.29775 23.8753 6.2528 23.8753 10.1124C23.8753 13.9719 23.8667 15.927 23.8497 15.927C23.8356 15.927 23.8241 15.9725 23.8241 16.0281C23.8241 16.0837 23.8126 16.1292 23.7986 16.1292C23.7845 16.1292 23.773 16.1633 23.773 16.2051C23.773 16.2468 23.7615 16.2809 23.7474 16.2809C23.7334 16.2809 23.7219 16.2982 23.7219 16.3193C23.7219 16.3693 23.4022 16.6854 23.3517 16.6854C23.3303 16.6854 23.3129 16.6968 23.3129 16.7107C23.3129 16.7246 23.2899 16.736 23.2618 16.736C23.2336 16.736 23.2106 16.7473 23.2106 16.7612C23.2106 16.7751 23.1761 16.7865 23.1339 16.7865C23.0918 16.7865 23.0573 16.7979 23.0573 16.8118C23.0573 16.8259 22.9891 16.8371 22.9039 16.8371C22.8187 16.8371 22.7505 16.8483 22.7505 16.8624C22.7505 16.8792 19.3166 16.8876 12.5 16.8876C5.68336 16.8876 2.24949 16.8792 2.24949 16.8624C2.24949 16.8483 2.18131 16.8371 2.09611 16.8371C2.01092 16.8371 1.94274 16.8259 1.94274 16.8118C1.94274 16.7979 1.90823 16.7865 1.86605 16.7865C1.82388 16.7865 1.78937 16.7751 1.78937 16.7612C1.78937 16.7473 1.76636 16.736 1.73824 16.736C1.71012 16.736 1.68712 16.7246 1.68712 16.7107C1.68712 16.6968 1.66966 16.6854 1.64829 16.6854C1.59775 16.6854 1.27812 16.3693 1.27812 16.3193C1.27812 16.2982 1.26662 16.2809 1.25256 16.2809C1.2385 16.2809 1.22699 16.2468 1.22699 16.2051C1.22699 16.1633 1.21549 16.1292 1.20143 16.1292C1.18737 16.1292 1.17587 16.0837 1.17587 16.0281C1.17587 15.9725 1.16437 15.927 1.15031 15.927C1.13333 15.927 1.12474 13.9719 1.12474 10.1124C1.12474 6.2528 1.13333 4.29775 1.15031 4.29775C1.16437 4.29775 1.17587 4.25225 1.17587 4.19663C1.17587 4.14101 1.18737 4.09551 1.20143 4.09551C1.21549 4.09551 1.22699 4.07275 1.22699 4.04494C1.22699 4.01713 1.2385 3.99438 1.25256 3.99438C1.26662 3.99438 1.27812 3.97163 1.27812 3.94382C1.27812 3.91601 1.28962 3.89326 1.30368 3.89326C1.31774 3.89326 1.32924 3.87589 1.32924 3.85468C1.32924 3.8045 1.54624 3.58989 1.59698 3.58989C1.61843 3.58989 1.63599 3.57851 1.63599 3.56461C1.63599 3.5507 1.659 3.53933 1.68712 3.53933C1.71524 3.53933 1.73824 3.52795 1.73824 3.51405C1.73824 3.50014 1.76125 3.48876 1.78937 3.48876C1.81748 3.48876 1.84049 3.47739 1.84049 3.46348C1.84049 3.44958 1.8865 3.4382 1.94274 3.4382C1.99898 3.4382 2.04499 3.42683 2.04499 3.41292C2.04499 3.39621 3.132 3.38764 5.25488 3.38764C8.64591 3.38764 8.53783 3.39115 8.53783 3.28126C8.53783 3.26247 8.56084 3.23072 8.58896 3.21067C8.61708 3.19063 8.64008 3.15399 8.64008 3.12924C8.64008 3.10452 8.65158 3.08427 8.66564 3.08427C8.6797 3.08427 8.69121 3.06152 8.69121 3.03371C8.69121 3.0059 8.70271 2.98315 8.71677 2.98315C8.73083 2.98315 8.74233 2.96039 8.74233 2.93258C8.74233 2.90478 8.75383 2.88202 8.76789 2.88202C8.78195 2.88202 8.79346 2.86177 8.79346 2.83705C8.79346 2.8123 8.81646 2.77567 8.84458 2.75562C8.8727 2.73557 8.89571 2.69894 8.89571 2.67419C8.89571 2.64946 8.90721 2.62921 8.92127 2.62921C8.93533 2.62921 8.94683 2.60646 8.94683 2.57865C8.94683 2.55084 8.95833 2.52809 8.97239 2.52809C8.98645 2.52809 8.99796 2.50534 8.99796 2.47753C8.99796 2.44972 9.00946 2.42697 9.02352 2.42697C9.03758 2.42697 9.04908 2.40672 9.04908 2.38199C9.04908 2.35724 9.07209 2.32061 9.1002 2.30056C9.12832 2.28051 9.15133 2.24388 9.15133 2.21913C9.15133 2.19441 9.16283 2.17416 9.17689 2.17416C9.19095 2.17416 9.20245 2.1514 9.20245 2.1236C9.20245 2.09579 9.21396 2.07303 9.22802 2.07303C9.24208 2.07303 9.25358 2.05028 9.25358 2.02247C9.25358 1.99466 9.26508 1.97191 9.27914 1.97191C9.2932 1.97191 9.3047 1.95166 9.3047 1.92694C9.3047 1.90219 9.32771 1.86555 9.35583 1.84551C9.38395 1.82546 9.40695 1.78883 9.40695 1.76408C9.40695 1.73935 9.41846 1.7191 9.43252 1.7191C9.44657 1.7191 9.45808 1.69635 9.45808 1.66854C9.45808 1.64073 9.46958 1.61798 9.48364 1.61798C9.4977 1.61798 9.5092 1.59522 9.5092 1.56742C9.5092 1.53961 9.52071 1.51685 9.53477 1.51685C9.54882 1.51685 9.56033 1.4966 9.56033 1.47188C9.56033 1.44713 9.58333 1.4105 9.61145 1.39045C9.63957 1.3704 9.66258 1.33377 9.66258 1.30902C9.66258 1.2843 9.67408 1.26404 9.68814 1.26404C9.7022 1.26404 9.7137 1.2465 9.7137 1.22506C9.7137 1.10973 9.57797 1.11433 13.006 1.11332L16.2344 1.11236L16.2972 1.17442ZM12.5767 4.52528C12.5767 4.53972 12.5 4.55056 12.3978 4.55056C12.2955 4.55056 12.2188 4.56141 12.2188 4.57584C12.2188 4.58975 12.1613 4.60112 12.091 4.60112C12.0207 4.60112 11.9632 4.6125 11.9632 4.6264C11.9632 4.64031 11.9057 4.65169 11.8354 4.65169C11.7651 4.65169 11.7076 4.66306 11.7076 4.67697C11.7076 4.69087 11.6731 4.70225 11.6309 4.70225C11.5887 4.70225 11.5542 4.71362 11.5542 4.72753C11.5542 4.74143 11.5197 4.75281 11.4775 4.75281C11.4353 4.75281 11.4008 4.76419 11.4008 4.77809C11.4008 4.79199 11.3663 4.80337 11.3241 4.80337C11.282 4.80337 11.2474 4.81475 11.2474 4.82865C11.2474 4.84256 11.2244 4.85393 11.1963 4.85393C11.1682 4.85393 11.1452 4.86531 11.1452 4.87921C11.1452 4.89312 11.1107 4.90449 11.0685 4.90449C11.0263 4.90449 10.9918 4.91587 10.9918 4.92978C10.9918 4.94368 10.9688 4.95506 10.9407 4.95506C10.9126 4.95506 10.8896 4.96643 10.8896 4.98034C10.8896 4.99424 10.8666 5.00562 10.8384 5.00562C10.8103 5.00562 10.7873 5.01699 10.7873 5.0309C10.7873 5.0448 10.7643 5.05618 10.7362 5.05618C10.7081 5.05618 10.6851 5.06756 10.6851 5.08146C10.6851 5.09537 10.6621 5.10674 10.6339 5.10674C10.6058 5.10674 10.5828 5.11812 10.5828 5.13202C10.5828 5.14593 10.5623 5.1573 10.5373 5.1573C10.5123 5.1573 10.4753 5.18006 10.455 5.20787C10.4347 5.23567 10.4002 5.25843 10.3783 5.25843C10.3564 5.25843 10.3219 5.28118 10.3016 5.30899C10.2814 5.3368 10.2469 5.35955 10.2249 5.35955C10.203 5.35955 10.1685 5.3823 10.1483 5.41011C10.128 5.43792 10.0956 5.46067 10.0762 5.46067C10.0568 5.46067 10.0087 5.4948 9.96933 5.53652C9.92993 5.57823 9.88494 5.61236 9.86938 5.61236C9.85381 5.61236 9.67439 5.77722 9.47065 5.97873C9.2669 6.18022 9.1002 6.35767 9.1002 6.37306C9.1002 6.38846 9.06569 6.43295 9.02352 6.47191C8.98134 6.51087 8.94683 6.55637 8.94683 6.57303C8.94683 6.58969 8.91232 6.6352 8.87014 6.67416C8.82796 6.71312 8.79346 6.7632 8.79346 6.78542C8.79346 6.80767 8.78195 6.82584 8.76789 6.82584C8.75383 6.82584 8.74233 6.84609 8.74233 6.87082C8.74233 6.89557 8.71933 6.9322 8.69121 6.95225C8.66309 6.97229 8.64008 7.00893 8.64008 7.03368C8.64008 7.0584 8.62858 7.07865 8.61452 7.07865C8.60046 7.07865 8.58896 7.1014 8.58896 7.12921C8.58896 7.15702 8.57745 7.17978 8.56339 7.17978C8.54934 7.17978 8.53783 7.20253 8.53783 7.23034C8.53783 7.25815 8.52633 7.2809 8.51227 7.2809C8.49821 7.2809 8.48671 7.30365 8.48671 7.33146C8.48671 7.35927 8.4752 7.38202 8.46115 7.38202C8.44709 7.38202 8.43558 7.40478 8.43558 7.43258C8.43558 7.46039 8.42408 7.48315 8.41002 7.48315C8.39596 7.48315 8.38446 7.5059 8.38446 7.53371C8.38446 7.56152 8.37296 7.58427 8.3589 7.58427C8.34484 7.58427 8.33333 7.60702 8.33333 7.63483C8.33333 7.66264 8.32183 7.68539 8.30777 7.68539C8.29371 7.68539 8.28221 7.71952 8.28221 7.76124C8.28221 7.80295 8.27071 7.83708 8.25665 7.83708C8.24259 7.83708 8.23108 7.87121 8.23108 7.91292C8.23108 7.95463 8.21958 7.98876 8.20552 7.98876C8.19146 7.98876 8.17996 8.02289 8.17996 8.06461C8.17996 8.10632 8.16846 8.14045 8.1544 8.14045C8.14034 8.14045 8.12883 8.18596 8.12883 8.24157C8.12883 8.29719 8.11733 8.3427 8.10327 8.3427C8.08921 8.3427 8.07771 8.39958 8.07771 8.4691C8.07771 8.53862 8.06621 8.59551 8.05215 8.59551C8.03809 8.59551 8.02658 8.65239 8.02658 8.72191C8.02658 8.79143 8.01508 8.84831 8.00102 8.84831C7.98459 8.84831 7.97546 9.10112 7.97546 9.55618C7.97546 10.0112 7.98459 10.264 8.00102 10.264C8.01523 10.264 8.02658 10.3315 8.02658 10.4157C8.02658 10.5 8.03793 10.5674 8.05215 10.5674C8.06621 10.5674 8.07771 10.6129 8.07771 10.6685C8.07771 10.7242 8.08921 10.7697 8.10327 10.7697C8.11733 10.7697 8.12883 10.8152 8.12883 10.8708C8.12883 10.9264 8.14034 10.9719 8.1544 10.9719C8.16846 10.9719 8.17996 11.006 8.17996 11.0478C8.17996 11.0895 8.19146 11.1236 8.20552 11.1236C8.21958 11.1236 8.23108 11.1577 8.23108 11.1994C8.23108 11.2412 8.24259 11.2753 8.25665 11.2753C8.27071 11.2753 8.28221 11.3094 8.28221 11.3511C8.28221 11.3928 8.29371 11.427 8.30777 11.427C8.32183 11.427 8.33333 11.4497 8.33333 11.4775C8.33333 11.5053 8.34484 11.5281 8.3589 11.5281C8.37296 11.5281 8.38446 11.5508 8.38446 11.5787C8.38446 11.6065 8.39596 11.6292 8.41002 11.6292C8.42408 11.6292 8.43558 11.6633 8.43558 11.7051C8.43558 11.7468 8.44709 11.7809 8.46115 11.7809C8.4752 11.7809 8.48671 11.8011 8.48671 11.8259C8.48671 11.8506 8.50971 11.8873 8.53783 11.9073C8.56595 11.9274 8.58896 11.964 8.58896 11.9887C8.58896 12.0135 8.60046 12.0337 8.61452 12.0337C8.62858 12.0337 8.64008 12.0565 8.64008 12.0843C8.64008 12.1121 8.65158 12.1348 8.66564 12.1348C8.6797 12.1348 8.69121 12.1551 8.69121 12.1798C8.69121 12.2046 8.71421 12.2412 8.74233 12.2612C8.77045 12.2813 8.79346 12.3154 8.79346 12.3371C8.79346 12.3587 8.81646 12.3929 8.84458 12.4129C8.8727 12.433 8.89571 12.4651 8.89571 12.4842C8.89571 12.5034 8.93021 12.5509 8.97239 12.5899C9.01457 12.6288 9.04908 12.6733 9.04908 12.6887C9.04908 12.7253 9.83244 13.5 9.8694 13.5C9.88497 13.5 9.92993 13.5341 9.96933 13.5758C10.0087 13.6176 10.0547 13.6517 10.0716 13.6517C10.0884 13.6517 10.1344 13.6858 10.1738 13.7275C10.2132 13.7692 10.2639 13.8034 10.2863 13.8034C10.3088 13.8034 10.3272 13.8147 10.3272 13.8287C10.3272 13.8426 10.3477 13.8539 10.3727 13.8539C10.3977 13.8539 10.4347 13.8767 10.455 13.9045C10.4753 13.9323 10.5123 13.9551 10.5373 13.9551C10.5623 13.9551 10.5828 13.9664 10.5828 13.9803C10.5828 13.9942 10.6058 14.0056 10.6339 14.0056C10.6621 14.0056 10.6851 14.017 10.6851 14.0309C10.6851 14.0448 10.7081 14.0562 10.7362 14.0562C10.7643 14.0562 10.7873 14.0676 10.7873 14.0815C10.7873 14.0954 10.8103 14.1067 10.8384 14.1067C10.8666 14.1067 10.8896 14.1181 10.8896 14.132C10.8896 14.1459 10.9126 14.1573 10.9407 14.1573C10.9688 14.1573 10.9918 14.1687 10.9918 14.1826C10.9918 14.1965 11.0148 14.2079 11.0429 14.2079C11.0711 14.2079 11.0941 14.2192 11.0941 14.2331C11.0941 14.2471 11.1286 14.2584 11.1708 14.2584C11.2129 14.2584 11.2474 14.2698 11.2474 14.2837C11.2474 14.2976 11.282 14.309 11.3241 14.309C11.3663 14.309 11.4008 14.3204 11.4008 14.3343C11.4008 14.3482 11.4353 14.3596 11.4775 14.3596C11.5197 14.3596 11.5542 14.3709 11.5542 14.3848C11.5542 14.3987 11.5887 14.4101 11.6309 14.4101C11.6731 14.4101 11.7076 14.4215 11.7076 14.4354C11.7076 14.4493 11.7536 14.4607 11.8098 14.4607C11.8661 14.4607 11.9121 14.4721 11.9121 14.486C11.9121 14.4999 11.9696 14.5112 12.0399 14.5112C12.1102 14.5112 12.1677 14.5226 12.1677 14.5365C12.1677 14.551 12.2444 14.5618 12.3466 14.5618C12.4489 14.5618 12.5256 14.5726 12.5256 14.5871C12.5256 14.6032 12.7301 14.6124 13.0879 14.6124C13.4458 14.6124 13.6503 14.6032 13.6503 14.5871C13.6503 14.5726 13.727 14.5618 13.8292 14.5618C13.9315 14.5618 14.0082 14.551 14.0082 14.5365C14.0082 14.5226 14.0542 14.5112 14.1104 14.5112C14.1667 14.5112 14.2127 14.4999 14.2127 14.486C14.2127 14.4721 14.2587 14.4607 14.3149 14.4607C14.3712 14.4607 14.4172 14.4493 14.4172 14.4354C14.4172 14.4215 14.4632 14.4101 14.5194 14.4101C14.5757 14.4101 14.6217 14.3987 14.6217 14.3848C14.6217 14.3709 14.6562 14.3596 14.6984 14.3596C14.7405 14.3596 14.7751 14.3482 14.7751 14.3343C14.7751 14.3204 14.7981 14.309 14.8262 14.309C14.8543 14.309 14.8773 14.2976 14.8773 14.2837C14.8773 14.2698 14.9118 14.2584 14.954 14.2584C14.9962 14.2584 15.0307 14.2471 15.0307 14.2331C15.0307 14.2192 15.0537 14.2079 15.0818 14.2079C15.1099 14.2079 15.1329 14.1965 15.1329 14.1826C15.1329 14.1687 15.1559 14.1573 15.184 14.1573C15.2122 14.1573 15.2352 14.1459 15.2352 14.132C15.2352 14.1181 15.2582 14.1067 15.2863 14.1067C15.3144 14.1067 15.3374 14.0954 15.3374 14.0815C15.3374 14.0676 15.3604 14.0562 15.3885 14.0562C15.4167 14.0562 15.4397 14.0448 15.4397 14.0309C15.4397 14.017 15.4627 14.0056 15.4908 14.0056C15.5189 14.0056 15.5419 13.9942 15.5419 13.9803C15.5419 13.9664 15.5649 13.9551 15.593 13.9551C15.6212 13.9551 15.6442 13.9437 15.6442 13.9298C15.6442 13.9159 15.6646 13.9045 15.6896 13.9045C15.7147 13.9045 15.7517 13.8817 15.772 13.8539C15.7923 13.8261 15.8268 13.8034 15.8487 13.8034C15.8706 13.8034 15.9051 13.7806 15.9254 13.7528C15.9456 13.725 15.9781 13.7022 15.9974 13.7022C16.0168 13.7022 16.0649 13.6681 16.1043 13.6264C16.1437 13.5847 16.1893 13.5506 16.2057 13.5506C16.222 13.5506 16.2914 13.4937 16.3599 13.4242C16.4284 13.3546 16.4969 13.2978 16.5122 13.2978C16.5482 13.2978 16.82 13.0292 16.82 12.9935C16.82 12.9786 16.8891 12.8993 16.9734 12.8174C17.0578 12.7355 17.1268 12.6554 17.1268 12.6394C17.1268 12.6233 17.1613 12.5783 17.2035 12.5393C17.2457 12.5004 17.2802 12.4528 17.2802 12.4337C17.2802 12.4145 17.3032 12.3824 17.3313 12.3624C17.3594 12.3423 17.3824 12.3057 17.3824 12.2809C17.3824 12.2562 17.3939 12.236 17.408 12.236C17.422 12.236 17.4335 12.2157 17.4335 12.191C17.4335 12.1662 17.4565 12.1296 17.4847 12.1096C17.5128 12.0895 17.5358 12.0529 17.5358 12.0281C17.5358 12.0034 17.5473 11.9831 17.5613 11.9831C17.5754 11.9831 17.5869 11.9604 17.5869 11.9326C17.5869 11.9048 17.5984 11.882 17.6125 11.882C17.6265 11.882 17.638 11.8593 17.638 11.8315C17.638 11.8037 17.6495 11.7809 17.6636 11.7809C17.6777 11.7809 17.6892 11.7581 17.6892 11.7303C17.6892 11.7025 17.7007 11.6798 17.7147 11.6798C17.7288 11.6798 17.7403 11.657 17.7403 11.6292C17.7403 11.6014 17.7518 11.5787 17.7658 11.5787C17.7799 11.5787 17.7914 11.5445 17.7914 11.5028C17.7914 11.4611 17.8029 11.427 17.817 11.427C17.831 11.427 17.8425 11.4042 17.8425 11.3764C17.8425 11.3486 17.854 11.3258 17.8681 11.3258C17.8822 11.3258 17.8937 11.2917 17.8937 11.25C17.8937 11.2083 17.9052 11.1742 17.9192 11.1742C17.9333 11.1742 17.9448 11.14 17.9448 11.0983C17.9448 11.0566 17.9563 11.0225 17.9703 11.0225C17.9844 11.0225 17.9959 10.977 17.9959 10.9213C17.9959 10.8657 18.0074 10.8202 18.0215 10.8202C18.0355 10.8202 18.047 10.7747 18.047 10.7191C18.047 10.6635 18.0585 10.618 18.0726 10.618C18.0868 10.618 18.0982 10.5506 18.0982 10.4663C18.0982 10.382 18.1095 10.3146 18.1237 10.3146C18.1391 10.3146 18.1493 10.2135 18.1493 10.0618C18.1493 9.91011 18.1595 9.80899 18.1748 9.80899C18.1902 9.80899 18.2004 9.70786 18.2004 9.55618C18.2004 9.40449 18.1902 9.30337 18.1748 9.30337C18.1595 9.30337 18.1493 9.20225 18.1493 9.05056C18.1493 8.89888 18.1391 8.79775 18.1237 8.79775C18.1095 8.79775 18.0982 8.73033 18.0982 8.64607C18.0982 8.56181 18.0868 8.49438 18.0726 8.49438C18.0585 8.49438 18.047 8.44888 18.047 8.39326C18.047 8.33764 18.0355 8.29213 18.0215 8.29213C18.0074 8.29213 17.9959 8.24663 17.9959 8.19101C17.9959 8.13539 17.9844 8.08989 17.9703 8.08989C17.9563 8.08989 17.9448 8.05576 17.9448 8.01404C17.9448 7.97233 17.9333 7.9382 17.9192 7.9382C17.9052 7.9382 17.8937 7.90407 17.8937 7.86236C17.8937 7.82065 17.8822 7.78652 17.8681 7.78652C17.854 7.78652 17.8425 7.76376 17.8425 7.73595C17.8425 7.70815 17.831 7.68539 17.817 7.68539C17.8029 7.68539 17.7914 7.65126 17.7914 7.60955C17.7914 7.56784 17.7799 7.53371 17.7658 7.53371C17.7518 7.53371 17.7403 7.51095 17.7403 7.48315C17.7403 7.45534 17.7288 7.43258 17.7147 7.43258C17.7007 7.43258 17.6892 7.40983 17.6892 7.38202C17.6892 7.35421 17.6777 7.33146 17.6636 7.33146C17.6495 7.33146 17.638 7.30871 17.638 7.2809C17.638 7.25309 17.6265 7.23034 17.6125 7.23034C17.5984 7.23034 17.5869 7.20758 17.5869 7.17978C17.5869 7.15197 17.5754 7.12921 17.5613 7.12921C17.5473 7.12921 17.5358 7.10896 17.5358 7.08424C17.5358 7.05949 17.5128 7.02286 17.4847 7.00281C17.4565 6.98276 17.4335 6.94863 17.4335 6.92697C17.4335 6.9053 17.4105 6.87117 17.3824 6.85112C17.3543 6.83108 17.3313 6.79695 17.3313 6.77528C17.3313 6.75361 17.3083 6.71949 17.2802 6.69944C17.252 6.67939 17.229 6.64731 17.229 6.62815C17.229 6.60901 17.1945 6.56143 17.1524 6.52247C17.1102 6.48351 17.0757 6.43904 17.0757 6.42365C17.0757 6.38712 16.2412 5.5618 16.2042 5.5618C16.1887 5.5618 16.1437 5.52767 16.1043 5.48595C16.0649 5.44424 16.0168 5.41011 15.9974 5.41011C15.9781 5.41011 15.9456 5.38736 15.9254 5.35955C15.9051 5.33174 15.868 5.30899 15.843 5.30899C15.818 5.30899 15.7975 5.29761 15.7975 5.28371C15.7975 5.2698 15.7771 5.25843 15.7521 5.25843C15.727 5.25843 15.69 5.23567 15.6697 5.20787C15.6495 5.18006 15.6124 5.1573 15.5874 5.1573C15.5624 5.1573 15.5419 5.14593 15.5419 5.13202C15.5419 5.11812 15.5189 5.10674 15.4908 5.10674C15.4627 5.10674 15.4397 5.09537 15.4397 5.08146C15.4397 5.06756 15.4167 5.05618 15.3885 5.05618C15.3604 5.05618 15.3374 5.0448 15.3374 5.0309C15.3374 5.01699 15.3144 5.00562 15.2863 5.00562C15.2582 5.00562 15.2352 4.99424 15.2352 4.98034C15.2352 4.96643 15.2122 4.95506 15.184 4.95506C15.1559 4.95506 15.1329 4.94368 15.1329 4.92978C15.1329 4.91587 15.1099 4.90449 15.0818 4.90449C15.0537 4.90449 15.0307 4.89312 15.0307 4.87921C15.0307 4.86531 14.9962 4.85393 14.954 4.85393C14.9118 4.85393 14.8773 4.84256 14.8773 4.82865C14.8773 4.81475 14.8428 4.80337 14.8006 4.80337C14.7584 4.80337 14.7239 4.79199 14.7239 4.77809C14.7239 4.76419 14.6894 4.75281 14.6472 4.75281C14.6051 4.75281 14.5706 4.74143 14.5706 4.72753C14.5706 4.71362 14.536 4.70225 14.4939 4.70225C14.4517 4.70225 14.4172 4.69087 14.4172 4.67697C14.4172 4.66306 14.3712 4.65169 14.3149 4.65169C14.2587 4.65169 14.2127 4.64031 14.2127 4.6264C14.2127 4.6125 14.1552 4.60112 14.0849 4.60112C14.0146 4.60112 13.9571 4.58975 13.9571 4.57584C13.9571 4.5611 13.8719 4.55056 13.7526 4.55056C13.6333 4.55056 13.5481 4.54002 13.5481 4.52528C13.5481 4.5093 13.3691 4.5 13.0624 4.5C12.7556 4.5 12.5767 4.5093 12.5767 4.52528ZM13.3436 5.63764C13.3436 5.65238 13.4288 5.66292 13.5481 5.66292C13.6674 5.66292 13.7526 5.67346 13.7526 5.6882C13.7526 5.70211 13.8101 5.71348 13.8804 5.71348C13.9507 5.71348 14.0082 5.72486 14.0082 5.73876C14.0082 5.75267 14.0542 5.76404 14.1104 5.76404C14.1667 5.76404 14.2127 5.77542 14.2127 5.78933C14.2127 5.80323 14.2472 5.81461 14.2894 5.81461C14.3315 5.81461 14.3661 5.82598 14.3661 5.83989C14.3661 5.85379 14.4006 5.86517 14.4427 5.86517C14.4849 5.86517 14.5194 5.87654 14.5194 5.89045C14.5194 5.90435 14.5424 5.91573 14.5706 5.91573C14.5987 5.91573 14.6217 5.92711 14.6217 5.94101C14.6217 5.95492 14.6447 5.96629 14.6728 5.96629C14.7009 5.96629 14.7239 5.97767 14.7239 5.99157C14.7239 6.00548 14.7469 6.01685 14.7751 6.01685C14.8032 6.01685 14.8262 6.02823 14.8262 6.04213C14.8262 6.05604 14.8492 6.06742 14.8773 6.06742C14.9054 6.06742 14.9284 6.07879 14.9284 6.0927C14.9284 6.1066 14.9514 6.11798 14.9796 6.11798C15.0077 6.11798 15.0307 6.12935 15.0307 6.14326C15.0307 6.15716 15.0512 6.16854 15.0761 6.16854C15.1012 6.16854 15.1382 6.19129 15.1585 6.2191C15.1788 6.24691 15.2133 6.26966 15.2352 6.26966C15.2571 6.26966 15.2916 6.29242 15.3119 6.32022C15.3321 6.34803 15.3646 6.37079 15.3839 6.37079C15.4033 6.37079 15.4514 6.40492 15.4908 6.44663C15.5302 6.48834 15.5752 6.52247 15.5908 6.52247C15.6279 6.52247 16.1554 7.04422 16.1554 7.08085C16.1554 7.0963 16.1899 7.14082 16.2321 7.17978C16.2743 7.21873 16.3088 7.26631 16.3088 7.28545C16.3088 7.30461 16.3318 7.33669 16.3599 7.35674C16.388 7.37679 16.411 7.41092 16.411 7.43258C16.411 7.45425 16.434 7.48838 16.4622 7.50843C16.4903 7.52847 16.5133 7.56511 16.5133 7.58986C16.5133 7.61458 16.5248 7.63483 16.5389 7.63483C16.5529 7.63483 16.5644 7.65758 16.5644 7.68539C16.5644 7.7132 16.5759 7.73595 16.59 7.73595C16.604 7.73595 16.6155 7.75871 16.6155 7.78652C16.6155 7.81433 16.627 7.83708 16.6411 7.83708C16.6552 7.83708 16.6667 7.85983 16.6667 7.88764C16.6667 7.91545 16.6782 7.9382 16.6922 7.9382C16.7063 7.9382 16.7178 7.96096 16.7178 7.98876C16.7178 8.01657 16.7293 8.03933 16.7434 8.03933C16.7574 8.03933 16.7689 8.07345 16.7689 8.11517C16.7689 8.15688 16.7804 8.19101 16.7945 8.19101C16.8085 8.19101 16.82 8.22514 16.82 8.26685C16.82 8.30857 16.8315 8.3427 16.8456 8.3427C16.8597 8.3427 16.8712 8.37683 16.8712 8.41854C16.8712 8.46025 16.8827 8.49438 16.8967 8.49438C16.9108 8.49438 16.9223 8.53989 16.9223 8.59551C16.9223 8.65112 16.9338 8.69663 16.9479 8.69663C16.9619 8.69663 16.9734 8.75351 16.9734 8.82303C16.9734 8.89256 16.9849 8.94944 16.999 8.94944C17.0153 8.94944 17.0245 9.16855 17.0245 9.55618C17.0245 9.94381 17.0153 10.1629 16.999 10.1629C16.9849 10.1629 16.9734 10.2198 16.9734 10.2893C16.9734 10.3588 16.9619 10.4157 16.9479 10.4157C16.9338 10.4157 16.9223 10.4612 16.9223 10.5169C16.9223 10.5725 16.9108 10.618 16.8967 10.618C16.8827 10.618 16.8712 10.6521 16.8712 10.6938C16.8712 10.7355 16.8597 10.7697 16.8456 10.7697C16.8315 10.7697 16.82 10.8038 16.82 10.8455C16.82 10.8872 16.8085 10.9213 16.7945 10.9213C16.7804 10.9213 16.7689 10.9555 16.7689 10.9972C16.7689 11.0389 16.7574 11.073 16.7434 11.073C16.7293 11.073 16.7178 11.0958 16.7178 11.1236C16.7178 11.1514 16.7063 11.1742 16.6922 11.1742C16.6782 11.1742 16.6667 11.1969 16.6667 11.2247C16.6667 11.2525 16.6552 11.2753 16.6411 11.2753C16.627 11.2753 16.6155 11.298 16.6155 11.3258C16.6155 11.3537 16.604 11.3764 16.59 11.3764C16.5759 11.3764 16.5644 11.3992 16.5644 11.427C16.5644 11.4548 16.5529 11.4775 16.5389 11.4775C16.5248 11.4775 16.5133 11.4978 16.5133 11.5225C16.5133 11.5473 16.4903 11.5839 16.4622 11.6039C16.434 11.624 16.411 11.6581 16.411 11.6798C16.411 11.7014 16.388 11.7356 16.3599 11.7556C16.3318 11.7757 16.3088 11.8077 16.3088 11.8269C16.3088 11.846 16.2743 11.8936 16.2321 11.9326C16.1899 11.9715 16.1554 12.0161 16.1554 12.0315C16.1554 12.0681 15.5767 12.6404 15.5397 12.6404C15.5241 12.6404 15.4791 12.6746 15.4397 12.7163C15.4003 12.758 15.3522 12.7921 15.3328 12.7921C15.3134 12.7921 15.281 12.8149 15.2607 12.8427C15.2405 12.8705 15.2034 12.8933 15.1784 12.8933C15.1534 12.8933 15.1329 12.9046 15.1329 12.9185C15.1329 12.9324 15.1124 12.9438 15.0874 12.9438C15.0624 12.9438 15.0254 12.9666 15.0051 12.9944C14.9848 13.0222 14.9478 13.0449 14.9228 13.0449C14.8978 13.0449 14.8773 13.0563 14.8773 13.0702C14.8773 13.0841 14.8543 13.0955 14.8262 13.0955C14.7981 13.0955 14.7751 13.1069 14.7751 13.1208C14.7751 13.1347 14.7405 13.1461 14.6984 13.1461C14.6562 13.1461 14.6217 13.1574 14.6217 13.1713C14.6217 13.1853 14.5987 13.1966 14.5706 13.1966C14.5424 13.1966 14.5194 13.208 14.5194 13.2219C14.5194 13.2358 14.4849 13.2472 14.4427 13.2472C14.4006 13.2472 14.3661 13.2586 14.3661 13.2725C14.3661 13.2864 14.3315 13.2978 14.2894 13.2978C14.2472 13.2978 14.2127 13.3091 14.2127 13.323C14.2127 13.3369 14.1782 13.3483 14.136 13.3483C14.0938 13.3483 14.0593 13.3597 14.0593 13.3736C14.0593 13.3875 14.0018 13.3989 13.9315 13.3989C13.8612 13.3989 13.8037 13.4103 13.8037 13.4242C13.8037 13.4386 13.727 13.4494 13.6247 13.4494C13.5225 13.4494 13.4458 13.4603 13.4458 13.4747C13.4458 13.4904 13.3009 13.5 13.0624 13.5C12.8238 13.5 12.6789 13.4904 12.6789 13.4747C12.6789 13.4603 12.6022 13.4494 12.5 13.4494C12.3978 13.4494 12.3211 13.4386 12.3211 13.4242C12.3211 13.4103 12.2635 13.3989 12.1933 13.3989C12.123 13.3989 12.0654 13.3875 12.0654 13.3736C12.0654 13.3597 12.0309 13.3483 11.9888 13.3483C11.9466 13.3483 11.9121 13.3369 11.9121 13.323C11.9121 13.3091 11.8776 13.2978 11.8354 13.2978C11.7932 13.2978 11.7587 13.2864 11.7587 13.2725C11.7587 13.2586 11.7242 13.2472 11.682 13.2472C11.6398 13.2472 11.6053 13.2358 11.6053 13.2219C11.6053 13.208 11.5823 13.1966 11.5542 13.1966C11.5261 13.1966 11.5031 13.1853 11.5031 13.1713C11.5031 13.1574 11.4801 13.1461 11.4519 13.1461C11.4238 13.1461 11.4008 13.1347 11.4008 13.1208C11.4008 13.1069 11.3688 13.0955 11.3298 13.0955C11.2881 13.0955 11.2435 13.0746 11.2219 13.0449C11.2016 13.0171 11.1646 12.9944 11.1395 12.9944C11.1145 12.9944 11.0941 12.983 11.0941 12.9691C11.0941 12.9552 11.0736 12.9438 11.0486 12.9438C11.0236 12.9438 10.9865 12.9211 10.9663 12.8933C10.946 12.8654 10.9115 12.8427 10.8896 12.8427C10.8677 12.8427 10.8332 12.8199 10.8129 12.7921C10.7926 12.7643 10.7602 12.7416 10.7408 12.7416C10.7214 12.7416 10.6733 12.7074 10.6339 12.6657C10.5946 12.624 10.5495 12.5899 10.5339 12.5899C10.4971 12.5899 10.0204 12.1189 10.0204 12.0826C10.0204 12.0674 9.97444 12.0113 9.9182 11.9579C9.86196 11.9044 9.81595 11.8453 9.81595 11.8264C9.81595 11.8075 9.79294 11.7757 9.76483 11.7556C9.73671 11.7356 9.7137 11.6989 9.7137 11.6742C9.7137 11.6495 9.7022 11.6292 9.68814 11.6292C9.67408 11.6292 9.66258 11.609 9.66258 11.5842C9.66258 11.5595 9.63957 11.5229 9.61145 11.5028C9.58333 11.4828 9.56033 11.4461 9.56033 11.4214C9.56033 11.3967 9.54882 11.3764 9.53477 11.3764C9.52071 11.3764 9.5092 11.3537 9.5092 11.3258C9.5092 11.298 9.4977 11.2753 9.48364 11.2753C9.46958 11.2753 9.45808 11.2525 9.45808 11.2247C9.45808 11.1969 9.44657 11.1742 9.43252 11.1742C9.41846 11.1742 9.40695 11.14 9.40695 11.0983C9.40695 11.0566 9.39545 11.0225 9.38139 11.0225C9.36733 11.0225 9.35583 10.9997 9.35583 10.9719C9.35583 10.9441 9.34433 10.9213 9.33027 10.9213C9.31621 10.9213 9.3047 10.8872 9.3047 10.8455C9.3047 10.8038 9.2932 10.7697 9.27914 10.7697C9.26508 10.7697 9.25358 10.7242 9.25358 10.6685C9.25358 10.6129 9.24208 10.5674 9.22802 10.5674C9.21396 10.5674 9.20245 10.5219 9.20245 10.4663C9.20245 10.4107 9.19095 10.3652 9.17689 10.3652C9.16268 10.3652 9.15133 10.2977 9.15133 10.2135C9.15133 10.1292 9.13998 10.0618 9.12577 10.0618C9.10959 10.0618 9.1002 9.87641 9.1002 9.55618C9.1002 9.23595 9.10959 9.05056 9.12577 9.05056C9.13998 9.05056 9.15133 8.98314 9.15133 8.89888C9.15133 8.81462 9.16268 8.74719 9.17689 8.74719C9.19095 8.74719 9.20245 8.70168 9.20245 8.64607C9.20245 8.59045 9.21396 8.54494 9.22802 8.54494C9.24208 8.54494 9.25358 8.49944 9.25358 8.44382C9.25358 8.3882 9.26508 8.3427 9.27914 8.3427C9.2932 8.3427 9.3047 8.30857 9.3047 8.26685C9.3047 8.22514 9.31621 8.19101 9.33027 8.19101C9.34433 8.19101 9.35583 8.16826 9.35583 8.14045C9.35583 8.11264 9.36733 8.08989 9.38139 8.08989C9.39545 8.08989 9.40695 8.05576 9.40695 8.01404C9.40695 7.97233 9.41846 7.9382 9.43252 7.9382C9.44657 7.9382 9.45808 7.91545 9.45808 7.88764C9.45808 7.85983 9.46958 7.83708 9.48364 7.83708C9.4977 7.83708 9.5092 7.81433 9.5092 7.78652C9.5092 7.75871 9.52071 7.73595 9.53477 7.73595C9.54882 7.73595 9.56033 7.7157 9.56033 7.69098C9.56033 7.66623 9.58333 7.6296 9.61145 7.60955C9.63957 7.5895 9.66258 7.55287 9.66258 7.52812C9.66258 7.5034 9.67408 7.48315 9.68814 7.48315C9.7022 7.48315 9.7137 7.46497 9.7137 7.44272C9.7137 7.4205 9.74821 7.37042 9.79039 7.33146C9.83257 7.2925 9.86708 7.24722 9.86708 7.23084C9.86708 7.21449 9.91309 7.15738 9.96933 7.10393C10.0256 7.05049 10.0716 6.99431 10.0716 6.9791C10.0716 6.94302 10.4457 6.57303 10.4822 6.57303C10.4975 6.57303 10.5543 6.52753 10.6084 6.47191C10.6624 6.41629 10.7222 6.37079 10.7413 6.37079C10.7604 6.37079 10.7926 6.34803 10.8129 6.32022C10.8332 6.29242 10.8677 6.26966 10.8896 6.26966C10.9115 6.26966 10.946 6.24691 10.9663 6.2191C10.9865 6.19129 11.0236 6.16854 11.0486 6.16854C11.0736 6.16854 11.0941 6.15716 11.0941 6.14326C11.0941 6.12935 11.1171 6.11798 11.1452 6.11798C11.1733 6.11798 11.1963 6.1066 11.1963 6.0927C11.1963 6.07879 11.2193 6.06742 11.2474 6.06742C11.2756 6.06742 11.2986 6.05604 11.2986 6.04213C11.2986 6.02823 11.3216 6.01685 11.3497 6.01685C11.3778 6.01685 11.4008 6.00548 11.4008 5.99157C11.4008 5.97767 11.4238 5.96629 11.4519 5.96629C11.4801 5.96629 11.5031 5.95492 11.5031 5.94101C11.5031 5.92711 11.5376 5.91573 11.5798 5.91573C11.6219 5.91573 11.6564 5.90435 11.6564 5.89045C11.6564 5.87654 11.6794 5.86517 11.7076 5.86517C11.7357 5.86517 11.7587 5.85379 11.7587 5.83989C11.7587 5.82598 11.7932 5.81461 11.8354 5.81461C11.8776 5.81461 11.9121 5.80323 11.9121 5.78933C11.9121 5.77542 11.9581 5.76404 12.0143 5.76404C12.0706 5.76404 12.1166 5.75267 12.1166 5.73876C12.1166 5.72486 12.1741 5.71348 12.2444 5.71348C12.3147 5.71348 12.3722 5.70211 12.3722 5.6882C12.3722 5.67346 12.4574 5.66292 12.5767 5.66292C12.696 5.66292 12.7812 5.65238 12.7812 5.63764C12.7812 5.62232 12.8919 5.61236 13.0624 5.61236C13.2328 5.61236 13.3436 5.62232 13.3436 5.63764Z"
              fill="black"
            />
          </svg>
          <div class="iu-widget-upload__text">
            <span class="iu-widget-upload__input">
              <span class="iu-widget-upload__text--desktop">Загрузи файлы</span
              ><span class="iu-widget-upload__text--mobile">Загрузи файлы</span>
            </span>
            <span class="iu-widget-upload__text--desktop">
              или перетащи в эту область</span
            >
          </div>
          <div class="iu-widget-upload__hint">
            <span class="iu-widget-upload__hint--desktop">
              Допустимые форматы: .jpg, .png, .mp4, .mov<br />
              не более 5 файлов.
              <br />
              Размер одного файла – не более 50 МБ.
              <br />
              Минимальное соотношение – не менее 480px на одну сторону.
            </span>
            <span class="iu-widget-upload__hint--mobile">
              Не более 5 файлов
            </span>
          </div>
          <input
            title="Загрузи файлы"
            type="file"
            multiple
            accept="image/x-png, image/png, image/jpeg, video/*"
            @change="uploadFromInput"
          />
        </div>
        <div
          v-if="uploadProcess || uploadedFiles.length"
          class="iu-widget-preview"
        >
          <div v-if="uploadProcess" class="iu-widget-upload__progress">
            <div class="iu-widget-upload__loader">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.3334 1.66699C19.4493 1.66699 18.6015 2.01818 17.9764 2.6433C17.3512 3.26842 17 4.11627 17 5.00032C17 5.88438 17.3512 6.73223 17.9764 7.35735C18.6015 7.98247 19.4493 8.33366 20.3334 8.33366C21.2174 8.33366 22.0653 7.98247 22.6904 7.35735C23.3155 6.73223 23.6667 5.88438 23.6667 5.00032C23.6667 4.11627 23.3155 3.26842 22.6904 2.6433C22.0653 2.01818 21.2174 1.66699 20.3334 1.66699ZM20.3334 32.5003C19.6703 32.5003 19.0345 32.7637 18.5656 33.2326C18.0968 33.7014 17.8334 34.3373 17.8334 35.0003C17.8334 35.6634 18.0968 36.2992 18.5656 36.7681C19.0345 37.2369 19.6703 37.5003 20.3334 37.5003C20.9964 37.5003 21.6323 37.2369 22.1011 36.7681C22.57 36.2992 22.8334 35.6634 22.8334 35.0003C22.8334 34.3373 22.57 33.7014 22.1011 33.2326C21.6323 32.7637 20.9964 32.5003 20.3334 32.5003ZM35.5 18.8337C35.058 18.8337 34.6341 19.0093 34.3215 19.3218C34.009 19.6344 33.8334 20.0583 33.8334 20.5003C33.8334 20.9424 34.009 21.3663 34.3215 21.6788C34.6341 21.9914 35.058 22.167 35.5 22.167C35.9421 22.167 36.366 21.9914 36.6786 21.6788C36.9911 21.3663 37.1667 20.9424 37.1667 20.5003C37.1667 20.0583 36.9911 19.6344 36.6786 19.3218C36.366 19.0093 35.9421 18.8337 35.5 18.8337ZM5.33337 17.0003C4.93941 17.0003 4.5493 17.0779 4.18532 17.2287C3.82135 17.3794 3.49063 17.6004 3.21205 17.879C2.93348 18.1576 2.7125 18.4883 2.56174 18.8523C2.41097 19.2162 2.33337 19.6064 2.33337 20.0003C2.33337 20.3943 2.41097 20.7844 2.56174 21.1484C2.7125 21.5124 2.93348 21.8431 3.21205 22.1216C3.49063 22.4002 3.82135 22.6212 4.18532 22.772C4.5493 22.9227 4.93941 23.0003 5.33337 23.0003C5.72734 23.0003 6.11745 22.9227 6.48143 22.772C6.8454 22.6212 7.17612 22.4002 7.4547 22.1216C7.73327 21.8431 7.95425 21.5124 8.10501 21.1484C8.25578 20.7844 8.33337 20.3943 8.33337 20.0003C8.33337 19.6064 8.25578 19.2162 8.10501 18.8523C7.95425 18.4883 7.73327 18.1576 7.4547 17.879C7.17612 17.6004 6.8454 17.3794 6.48143 17.2287C6.11745 17.0779 5.72734 17.0003 5.33337 17.0003ZM31 5.16699C29.895 5.16699 28.8352 5.60598 28.0538 6.38738C27.2724 7.16878 26.8334 8.22859 26.8334 9.33366C26.8334 10.4387 27.2724 11.4985 28.0538 12.2799C28.8352 13.0613 29.895 13.5003 31 13.5003C32.1051 13.5003 33.1649 13.0613 33.9463 12.2799C34.7277 11.4985 35.1667 10.4387 35.1667 9.33366C35.1667 8.22859 34.7277 7.16878 33.9463 6.38738C33.1649 5.60598 32.1051 5.16699 31 5.16699ZM9.66671 27.667C8.87106 27.667 8.108 27.9831 7.54539 28.5457C6.98278 29.1083 6.66671 29.8713 6.66671 30.667C6.66671 31.4626 6.98278 32.2257 7.54539 32.7883C8.108 33.3509 8.87106 33.667 9.66671 33.667C10.4624 33.667 11.2254 33.3509 11.788 32.7883C12.3506 32.2257 12.6667 31.4626 12.6667 30.667C12.6667 29.8713 12.3506 29.1083 11.788 28.5457C11.2254 27.9831 10.4624 27.667 9.66671 27.667ZM31 28.667C30.7374 28.667 30.4773 28.7187 30.2347 28.8192C29.992 28.9197 29.7715 29.0671 29.5858 29.2528C29.4001 29.4385 29.2528 29.659 29.1523 29.9016C29.0518 30.1443 29 30.4043 29 30.667C29 30.9296 29.0518 31.1897 29.1523 31.4324C29.2528 31.675 29.4001 31.8955 29.5858 32.0812C29.7715 32.2669 29.992 32.4142 30.2347 32.5147C30.4773 32.6153 30.7374 32.667 31 32.667C31.2627 32.667 31.5228 32.6153 31.7654 32.5147C32.0081 32.4142 32.2285 32.2669 32.4143 32.0812C32.6 31.8955 32.7473 31.675 32.8478 31.4324C32.9483 31.1897 33 30.9296 33 30.667C33 30.4043 32.9483 30.1443 32.8478 29.9016C32.7473 29.659 32.6 29.4385 32.4143 29.2528C32.2285 29.0671 32.0081 28.9197 31.7654 28.8192C31.5228 28.7187 31.2627 28.667 31 28.667ZM9.66671 6.33366C9.27274 6.33366 8.88263 6.41126 8.51866 6.56202C8.15468 6.71278 7.82396 6.93376 7.54539 7.21234C7.26681 7.49091 7.04583 7.82163 6.89507 8.18561C6.74431 8.54958 6.66671 8.93969 6.66671 9.33366C6.66671 9.72762 6.74431 10.1177 6.89507 10.4817C7.04583 10.8457 7.26681 11.1764 7.54539 11.455C7.82396 11.7336 8.15468 11.9545 8.51866 12.1053C8.88263 12.2561 9.27274 12.3337 9.66671 12.3337C10.0607 12.3337 10.4508 12.2561 10.8148 12.1053C11.1787 11.9545 11.5095 11.7336 11.788 11.455C12.0666 11.1764 12.2876 10.8457 12.4383 10.4817C12.5891 10.1177 12.6667 9.72762 12.6667 9.33366C12.6667 8.93969 12.5891 8.54958 12.4383 8.18561C12.2876 7.82163 12.0666 7.49091 11.788 7.21234C11.5095 6.93376 11.1787 6.71278 10.8148 6.56202C10.4508 6.41126 10.0607 6.33366 9.66671 6.33366Z"
                  fill="#000"
                />
              </svg>
            </div>
            Обработано {{ filesProcessed }} из
            {{ filesToUpload.length }} файлов.&nbsp;
            <span v-if="isVideoCompression"> Сжатие медиа </span>
            <span v-else> Загрузка медиа </span>
          </div>
          <div class="iu-widget__media-list">
            <div
              v-for="(media, index) in uploadedFiles"
              :key="media.id"
              class="iu-widget__media-item"
            >
              <img
                ref="uploadedImages"
                :src="media.url"
                class="iu-widget-item-image"
                @error="reloadImage(index, media.url)"
              />
              <div
                class="iu-widget-item-close"
                @click="uploadedFiles.splice(index, 1)"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1C8.33333 8.33333 23 23 23 23"
                    stroke="#7C0000"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M23 1C15.6667 8.33333 1 23 1 23"
                    stroke="#7C0000"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!uploadProcess && error"
          class="iu-widget-message iu-widget-upload__error"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2ZM0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM12 16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16C10 15.4477 10.4477 15 11 15C11.5523 15 12 15.4477 12 16ZM12 6C12 5.44772 11.5523 5 11 5C10.4477 5 10 5.44772 10 6L10 13C10 13.5523 10.4477 14 11 14C11.5523 14 12 13.5523 12 13L12 6Z"
              fill="#2C2C2C"
            />
          </svg>
          <span>{{ error }}</span>
        </div>
        <label class="iu-widget-checkbox">
          <input v-model="agreedWithRules" type="checkbox" />
          <div class="iu-widget-checkbox__toggle" />
          <div
            v-if="settings.personal_data_agreement_content"
            class="iu-widget-checkbox__label"
            v-html="settings.personal_data_agreement_content"
          />
          <div v-else class="iu-widget-checkbox__label">
            Согласен с
            <a :href="settings.link_personal_data_agreement" target="_blank"
              >Правилами</a
            >
            обработки<br />
            персональных данных
          </div>
        </label>
        <div class="iu-widget__controls">
          <div
            class="iu-widget__next-button"
            :class="{
              'iu-widget__next-button--disabled':
                uploadProcess || !uploadedFiles.length || !agreedWithRules,
            }"
            @click="saveAsPost"
          >
            Опубликовать
          </div>
        </div>
        <div class="iu-widget__title iu-widget__title--notice">
          — обязательно для заполнения
        </div>
      </template>
      <template v-else>
        <div class="iu-widget-message iu-widget-message-congrats">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11ZM11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM15.9069 9.00691C16.2974 8.61639 16.2974 7.98322 15.9069 7.5927C15.5164 7.20217 14.8832 7.20217 14.4927 7.5927L9.7998 12.2856L7.50691 9.9927C7.11639 9.60217 6.48322 9.60217 6.0927 9.9927C5.70217 10.3832 5.70217 11.0164 6.0927 11.4069L9.0927 14.4069C9.48322 14.7974 10.1164 14.7974 10.5069 14.4069L15.9069 9.00691Z"
              fill="#2C2C2C"
            />
          </svg>
          <span>
            Контент успешно отправлен на модерацию.
            <span>
              В случае успешной публикации вы получите уведомление на почту.
            </span>
          </span>
        </div>
      </template>
      <div
        v-if="inDrag"
        class="iu-widget-drop-area"
        :class="{
          'iu-widget-drop-area--limited': limitIsFull || uploadProcess,
        }"
      >
        <svg
          width="134"
          height="134"
          viewBox="0 0 134 134"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M67 122.834C97.8359 122.834 122.833 97.8362 122.833 67.0003C122.833 36.1644 97.8359 11.167 67 11.167C36.1641 11.167 11.1667 36.1644 11.1667 67.0003C11.1667 97.8362 36.1641 122.834 67 122.834Z"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M67 39.083L67 94.9163"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M39.0833 67L94.9166 67"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
// Modules
import axios from "axios";
// Mixins
import analytics from "../common/mixins/analytics";
// Services
import { redirectToAuthPage } from "./services";
// Services
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";

export default {
  mixins: [analytics],

  props: ["propSettings"],
  data() {
    const { logged_in_email, logged_in_id } = this.propSettings;

    return {
      settings: this.propSettings || {},
      maxLimit: 5,
      isShow: true,
      currentStep: "upload",
      filesToUpload: null,
      filesProcessed: 0,
      uploadedFiles: [],
      uploadProcess: false,
      error: null,
      username: logged_in_id || "",
      email: logged_in_email || "",
      caption: "",
      agreedWithRules: false,
      inDrag: false,
      labelItemPosition: ["url", "friPostId", "uploadPhotoCount"],
      categoryPostfix: "IUpload",
      isVideoCompression: false,
    };
  },
  mounted() {
    document.addEventListener("frisbuy:iu-open", this.showPopup);
  },
  beforeUnmount() {
    document.removeEventListener("frisbuy:iu-open", this.showPopup);
  },
  computed: {
    limitIsFull() {
      const { uploadedFiles, maxLimit } = this;

      return uploadedFiles.length >= maxLimit;
    },

    trackingSkuId() {
      const { skuId, groupId, categoryId } = this.settings;

      return (
        (skuId && `_sku${skuId}`) ||
        (groupId && `_skug${groupId}`) ||
        (categoryId && `_cat${categoryId}`) ||
        ""
      );
    },

    isUserLoggedIn() {
      const { logged_in_id, logged_in_email, logged_in_phone } = this.settings;

      return !!logged_in_id && !!logged_in_email && !!logged_in_phone;
    },
  },

  watch: {
    currentStep(newStepName, oldStepName) {
      if (newStepName === "post") {
        this.sendAnalyticEvent("UplphotoUploaded", {
          link: location.href,
          linklabel: document.title,
        });
      }

      if (oldStepName === "upload") return;

      this.error = null;
    },

    isShow: {
      handler(value) {
        const { logged_in_email, logged_in_id } = this.settings;

        if (value) {
          this.sendAnalyticEvent("UplphotoOpen");

          if (this.settings.auth_page_url && !this.isUserLoggedIn) {
            const backUrl = window.location.href;
            redirectToAuthPage(this.settings.auth_page_url, backUrl);

            this.closePopup();
            return;
          }

          this.$nextTick(() => {
            const { $el } = this;

            document.body.appendChild($el);

            this.lockWindowScroll();
          });

          return;
        }

        this.unlockWindowScroll();

        this.currentStep = "upload";
        this.filesToUpload = null;
        this.filesProcessed = 0;
        this.uploadedFiles = [];
        this.uploadProcess = false;
        this.error = null;
        this.caption = "";
        this.username = logged_in_id || "";
        this.email = logged_in_email || "";
        this.agreedWithRules = false;
      },

      immediate: true,
    },
  },

  methods: {
    lockWindowScroll() {
      const customScrollElement = this.settings.scrollElement;
      const scrollElement = customScrollElement || "body";
      document.querySelector(scrollElement).style.overflow = "hidden";
    },

    unlockWindowScroll() {
      const customScrollElement = this.settings.scrollElement;
      const scrollElement = customScrollElement || "body";
      document.querySelector(scrollElement).style.overflow = "";
    },

    showPopup() {
      this.isShow = true;
    },

    closePopup() {
      this.isShow = false;
    },

    componentAction({ action }) {
      const { settings, trackingSkuId } = this;

      return `${action}_embedID${settings.embedId + trackingSkuId}`;
    },

    uploadFromDrop(event) {
      const {
        uploadFiles,
        uploadedFiles,
        maxLimit,
        limitIsFull,
        uploadProcess,
      } = this;
      const { files } = event.dataTransfer;

      this.inDrag = false;

      if (limitIsFull || uploadProcess) return;

      this.filesToUpload = [...files].slice(0, maxLimit - uploadedFiles.length);

      uploadFiles();
    },

    uploadFromInput(event) {
      const {
        uploadFiles,
        uploadedFiles,
        maxLimit,
        limitIsFull,
        uploadProcess,
      } = this;
      const { files } = event.target;

      if (limitIsFull || uploadProcess) return;

      this.filesToUpload = [...files].slice(0, maxLimit - uploadedFiles.length);

      uploadFiles();
    },

    uploadFiles() {
      const { filesToUpload, settings } = this;
      const { srcDomain, embedId } = settings;

      this.uploadProcess = true;
      this.filesProcessed = 0;
      this.error = null;

      filesToUpload.forEach((file) => {
        const formData = new FormData();

        formData.append("file", file, file.name);

        if (file.size > 50 * 1024 * 1024) {
          this.filesProcessed += 1;
          this.error = `${this.error || ""}Файл превышает размер 50 мегабайт`;

          if (this.filesProcessed !== filesToUpload.length) return;

          this.uploadProcess = false;
          this.filesToUpload = [];
          this.currentStep = "preview";

          return;
        }

        axios({
          url: DomainSubstitute(`${srcDomain}/api/1.0.0/customer/medias?embed_id=${embedId}`),
          method: "POST",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progress) => {
            const isUploaded = progress.total === progress.loaded;

            if (isUploaded) {
              this.isVideoCompression = true;
            }
          },
        })
          .then(({ data }) => {
            const { request, response } = data;
            const { success, statusMessage } = request;
            const { post_media } = response.body;

            if (!success) {
              this.error = statusMessage;
              return;
            }

            this.uploadedFiles.push(post_media);
          })
          .catch((error) => {
            const { response } = error;

            this.sendAnalyticEvent("UplphotoError", {
              link: location.href,
              linklabel: document.title,
              error: this.error,
            });

            if (!response || typeof response.data.request === "string") {
              if (error && response && response.status === 413) {
                this.error =
                  (this.error || "") +
                  `Файл '${file.name}' превышает размер 50 мегабайт` +
                  "\n";
                return;
              }

              this.error = "Ошибка на сервере, попробуйте позже";
              return;
            }

            if (this.error === null) {
              this.error = `${response.data.request.error}\n`;
            } else {
              this.error += `${response.data.request.error}\n`;
            }
          })
          .finally(() => {
            this.filesProcessed += 1;

            if (this.filesProcessed !== filesToUpload.length) return;

            this.uploadProcess = false;
            this.isVideoCompression = false;
            this.filesToUpload = [];
            this.currentStep = "preview";
          });
      });
    },

    saveAsPost() {
      let {
        uploadedFiles,
        username,
        email,
        agreedWithRules,
        settings,
        caption,
      } = this;
      const { srcDomain, embedId, logged_in_id } = settings;
      const emailReg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      email = email.trim();
      this.error = null;

      if (!username) {
        this.error = "Пожалуйста, введите имя";
        return;
      }
      if (!email || !emailReg.test(email)) {
        this.error = "Пожалуйста, введите правильный E-mail адрес";
        return;
      }
      if (!agreedWithRules) {
        this.error =
          "Пожалуйста, подтвердите ознакомление с правилами пользования сайтом";
        return;
      }

      axios({
        url: DomainSubstitute(`${srcDomain}/api/1.0.0/customer/posts?embed_id=${embedId}`),
        method: "POST",
        data: {
          post_medias: uploadedFiles,
          email,
          username,
          logged_in_id,
          caption,
          url: encodeURIComponent(location.href),
        },
      })
        .then(({ data }) => {
          const { success, statusMessage } = data.request;

          if (!success) {
            this.error = statusMessage;
            return;
          }

          this.sendAnalyticEvent("UplphotoOK", {
            url: location.href,
            uploadPhotoCount: uploadedFiles.length,
            link: location.href,
            linklabel: document.title,
          });

          this.currentStep = "congrats";

          setTimeout(() => {
            this.isShow = false;
          }, 3000);
        })
        .catch((error) => {
          const { response } = error;

          this.sendAnalyticEvent("UplphotoError", {
            link: location.href,
            linklabel: document.title,
            error: this.error,
          });

          if (response) {
            const { data } = response;

            this.error = data.request.error;
          } else {
            this.error = "Ошибка на сервере, попробуйте позже";
          }
        });
    },

    reloadImage(index, url) {
      /*
        NOTE: Backend cache return 404 error.
        To update cache I use random query param
      */
      const randomValue = Math.random().toString().slice(2);
      const randomQueryParam = `random_query_param=${randomValue}`;

      const fixedUrl = `${url}?recovery=true&${randomQueryParam}`;
      this.$refs.uploadedImages[index].src = fixedUrl;
    },
  },
};
</script>

<style lang="scss">
.iu-widget__overlay {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  background-color: rgba(77, 77, 77, 0.4);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  min-width: 100svw;
  min-height: 100svh;
  z-index: 99999999999999;
  animation: iu-show 0.2s linear;
  color: #2c2c2c;

  * {
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-button {
      width: 0px;
      height: 0px;
    }

    &::-webkit-scrollbar-thumb {
      background: #a4a4a4;
      border: 0px none #ffffff;
      border-radius: 50px;
    }

    &::-webkit-scrollbar-thumb:hover,
    &::-webkit-scrollbar-thumb:active {
      background: #a4a4a4;
    }

    &::-webkit-scrollbar-track {
      background: #ffffff;
      border: 0px none #ffffff;
      border-radius: 50px;
    }

    &::-webkit-scrollbar-track:hover,
    &::-webkit-scrollbar-track:active {
      background: #ffffff;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }
  }

  a {
    color: inherit;
    text-decoration: none;
    border-bottom: 1px solid #c0c0c0;
  }

  &.iu-widget--in-drag {
    .iu-widget__popup {
      pointer-events: none;
    }
  }
}

.iu-widget__popup {
  width: 730px;
  background: #ffffff;
  padding: 24px 127px 24px;
  position: relative;
  max-height: 97%;
  border-radius: 8px;
  overflow: auto;
}

.iu-widget-drop-area {
  position: absolute;
  background-color: rgba(30, 129, 189, 0.15);
  backdrop-filter: blur(5px);
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &.iu-widget-drop-area--limited {
    background-color: rgba(189, 30, 30, 0.15);
    svg {
      transform: rotate(45deg);
    }
  }
}

.iu-widget__close {
  position: absolute;
  top: 17px;
  right: 17px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.iu-widget__title {
  font-size: 28px;
  line-height: 33px;

  &.iu-widget__title--medium {
    font-weight: 300;
    font-size: 14px;
    line-height: 21px;
  }

  &.iu-widget__title--add-photo {
    margin-top: 10px;
  }

  &.iu-widget__title--notice {
    font-weight: 300;
    font-size: 14px;
    line-height: 18px;

    &:before {
      content: "*";
      color: #b80000;
    }
  }
}

.iu-widget--required {
  &:after {
    content: "*";
    color: #b80000;
  }
}

.iu-widget-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px dashed#D2D2D2;
  border-radius: 5px;
  margin: 10px 0;
  padding: 57px 32px;
  position: relative;
  background-color: rgba(0, 0, 0, 0.03);

  + .iu-widget-upload__error {
    margin-top: 0;

    span {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  input {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    cursor: pointer;
  }
}

.iu-widget-upload--short {
  padding: 10px 10px 10px 100px;
  align-items: flex-start;
  position: relative;

  svg {
    width: 24px;
    height: 24px;
    position: absolute;
    top: calc(50% - 12px);
    left: 38px;
  }

  .iu-widget-upload__text {
    text-align: left;
    margin-top: 0;
  }

  .iu-widget-upload__hint {
    text-align: left;
    margin-top: 12px;
  }
}

.iu-widget-upload__text {
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  margin-top: 16px;

  .iu-widget-upload__text--mobile {
    display: none;
  }
}

.iu-widget-upload__input {
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid #c0c0c0;
  line-height: 21px;
}

.iu-widget-upload__hint {
  font-size: 12px;
  line-height: 16px;
  color: #5e5e5e;
  text-align: center;
  margin-top: 12px;

  .iu-widget-upload__hint--mobile {
    display: none;
  }
}

.iu-widget-preview {
  margin: 5px 0 0;
}

.iu-widget-upload__loader {
  svg {
    margin-right: 20px;
    animation: spin 1s infinite linear;
  }
}

.iu-widget-upload__progress {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 18px 6px;
  color: #959595;
  font-size: 13px;
  line-height: 22px;
}

.iu-widget__media-list {
  display: flex;
  flex-wrap: wrap;
  margin: -5px;
}

.iu-widget__media-item {
  width: 65px;
  height: 79px;
  border-radius: 10px;
  margin: 8px;
  background-color: #eaeaea;
  background-size: cover;
  position: relative;

  .iu-widget-item-close {
    position: absolute;
    background: #ffffff;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 100%;
    left: calc(50% - 13px);
    bottom: -13px;
    cursor: pointer;
  }

  .iu-widget-item-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
}

.iu-widget__controls {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.iu-widget__next-button {
  padding: 9px 32px;
  background: #000;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  width: 224px;
  color: #ffffff;
  display: inline-block;
  cursor: pointer;
  text-align: center;
  margin-top: 10px;

  &.iu-widget__next-button--disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}

.iu-widget__post-form {
  display: flex;
  flex-direction: column;
  margin: 10px 0;

  label {
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
  }

  input[type="text"],
  textarea {
    font-size: 16px;
    line-height: 22px;
    color: #2c2c2c;
    padding: 5px 6px;
    border: 1px solid #d5d5d5;
    border-radius: 5px;
    margin: 4px 0 6px;
  }

  textarea {
    resize: vertical;
    box-shadow: 1px 1px 7px rgba(0, 0, 0, 0.15);

    &::placeholder {
      opacity: 0.8;
    }
  }

  .iu-widget__title {
    margin-bottom: 10px;
  }
}

.iu-widget-checkbox {
  margin-top: 10px;
  position: relative;
  display: flex;

  input[type="checkbox"] {
    position: absolute;
    opacity: 0;

    &:checked + .iu-widget-checkbox__toggle:before {
      content: "";
      width: 6px;
      height: 4px;
      border-width: 0 0 2px 2px;
      border-style: solid;
      border-color: #000;
      transform: rotate(-45deg);
      margin: -3px 0 0;
    }
  }
}

.iu-widget-checkbox__toggle {
  border: 2px solid #000;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.iu-widget-checkbox__label {
  font-weight: 300;
  font-size: 14px;
  line-height: 18px;
  margin-right: 18px;
}

.iu-widget-message {
  background-color: #f4f4f4;
  padding: 18px 26px;
  display: flex;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;

  svg {
    margin-right: 14px;
    flex-shrink: 0;
  }
}

.iu-widget-upload__error {
  margin-top: 24px;

  background-color: #fcd8d9;

  & + .iu-widget-preview {
    margin-top: 0;
  }
}

.iu-widget-message-congrats {
  span {
    display: block;
  }
}

@media (max-width: 768px) {
  .iu-widget-upload__text {
    .iu-widget-upload__text--desktop {
      display: none;
    }

    .iu-widget-upload__text--mobile {
      display: inherit;
    }
  }

  .iu-widget-upload__hint {
    .iu-widget-upload__hint--desktop {
      display: none;
    }

    .iu-widget-upload__hint--mobile {
      display: inherit;
    }
  }
}

@media (max-width: 568px) {
  .iu-widget__overlay {
    overflow-y: auto;
    overflow-x: hidden;
    align-items: flex-start;
    min-width: auto;
    min-height: auto;
  }

  .iu-widget__popup {
    width: 100%;
    min-height: 100%;
    max-height: auto;
    display: flex;
    flex-direction: column;
    padding: 24px;
    border-radius: 0;
  }

  .iu-widget__close {
    width: 16px;
    height: 16px;
  }
  .iu-widget-upload {
    // flex-grow: 1;
    justify-content: center;
  }

  .iu-widget-upload--short {
    padding-left: 72px;

    svg {
      left: 26px;
    }

    .iu-widget-upload__hint {
      margin-top: 8px;
    }

    & + .iu-widget-upload__error {
      margin-top: 8px;
    }
  }

  .iu-widget-upload__progress {
    flex-direction: column;
    margin-bottom: 8px;

    svg {
      margin: 0 0 18px 0;
    }
  }

  .iu-widget-preview {
    flex-grow: 1;
  }

  .iu-widget__media-item {
    width: 45px;
    height: 59px;
    margin: 6px;
  }

  .iu-widget-message-congrats {
    span {
      display: inline-block;
    }
  }
}
</style>
